import { IDoctor } from "@curefit/care-common";
import ApiUtils from "../utils/ApiUtils";
import { IAppointmentScheduleRequestParams } from "../models/IAppointmentScheduleRequestParams"
import { IStaticDataRequestParams } from "../models/request/IStaticDataRequestParams"
import IResourceRequestParams from "../models/IResourceRequestParams";
import { EHR_SERVICE_API_PREFIX, MAVERICK_API_PREFIX, ORION_API_PREFIX, METRIC_SERVICE_API_TARGET, METRIC_SERVICE_API_PREFIX } from "../../../common/configs/configs";

import { ICommAccessTokenRequestParams } from "../models/ICommAccessTokenRequestParams";
import { IOrderEvent } from "../models/order/IOrderEvent"
import IDiagnosticOrderRequestParams from "../models/IDiagnosticOrderRequestParams";
import { DOCTOR_ID_PARAM, PATIENT_ID_PARAM } from "../routes";
import { IUnreadMsgInfoRequestParams } from "../models/twilio/IUnreadMsgInfoRequestParams";
import ISearchDoctor from "../models/ISearchDoctor";
import { labTestCategories, PushNotificationPlatform } from "../utils/AppConstants";
import { IRosterRequest } from "../models/Roster/IRosterRequest";
import AppUtils from "../utils/AppUtils";
export const USER_ID_PARAM_CONST = "$userId";
export const PATIENT_PATH_PARAM_CONST = "$patientId";
export const APPOINTMENT_ID_PARAM_CONST = "$appointmentId";
export const BOOKING_ID_PARAM_CONST = "$bookingId";
export const ORDER_ID_PARAM_CONST = "$orderId";
export const CENTER_ID_PARAM_CONST = "$centerId";
export const ASSET_ID_PARAM_CONST = "$assetId";

export const ALBUS_API_PREFIX = "/albus";
// export const ALBUS_SUGARFIT_API_PREFIX = "/albus-sugarfit";
export const EHR_API_PREFIX = "/ehr";

export const POLARIS_API_PREFIX = "/polaris";
export const SIG_URL = "/aws/sig";

export const OLLIVANDER_PREFIX = "  /ollivander";
export const CARE_RECOMMENDATION_SERVICE = "/care-recommendation-service";

export const GET_DOC_PROFILES = ALBUS_API_PREFIX + "/getDoctors";
export const GET_DOC_PROFILE_BY_ID = ALBUS_API_PREFIX + "/getDoctorForId";
export const SAVE_DOC_PROFILE_BY_ID = ALBUS_API_PREFIX + "/saveDoctorProfile";
export const GET_PATIENT_PROFILE = ALBUS_API_PREFIX + "/getPatient";
export const LOG_ORDER_EVENT_URL = ALBUS_API_PREFIX + "/order/log-events";

/* ehr */
export const GET_PATIENT_COMPLETE_DETAILS_URL = EHR_API_PREFIX + "/getAllDetailsForPatient";
export const GET_APPOINTMENT_DETAILS_BY_ID = ALBUS_API_PREFIX + "/getAppointmentDetails";
export const GET_ALL_COMORBID_CONDITION_FOR_PATIENT = EHR_API_PREFIX + "/getAllComorbidConditionForPatient";
export const GET_SURGERY_AND_PROCEDURE_HISTORY = EHR_API_PREFIX + "/getAllSurgeryAndProcedureForPatient";
export const SAVE_SURGERY_AND_PROCEDURE_HISTORY = EHR_API_PREFIX + "/saveSurgeryAndProcedureForPatient";
export const GET_ALLERGY_HISTORY = EHR_API_PREFIX + "/getAllAllergyForPatient";
export const GET_PAST_SESSIONS = EHR_API_PREFIX + "/sub-sections/data/history"
export const SAVE_ALLERGY_HISTORY = EHR_API_PREFIX + "/saveAllergyForPatient";
export const GET_HABIT_HISTORY = EHR_API_PREFIX + "/getAllHabitForPatient";
export const SAVE_HABIT_HISTORY = EHR_API_PREFIX + "/saveHabitForPatient";
export const GET_CURRENT_MEDICATION_HISTORY = EHR_API_PREFIX + "/getAllCurrentMedicationForPatient";
export const SAVE_CURRENT_MEDICATION_HISTORY = EHR_API_PREFIX + "/saveCurrentMedicationForPatient";
export const GET_COMORBID_CONDITIONS_HISTORY = EHR_API_PREFIX + "/getAllComorbidConditionForPatient";
export const SAVE_COMORBID_CONDITIONS_HISTORY = EHR_API_PREFIX + "/saveComorbidConditionForPatient";
export const GET_DOCTOR_SUBSECTION_RECOMMENDATIONS_URL = EHR_API_PREFIX + "/recommendations";
export const GET_TREATMENT_PLAN_TEMPLATES_URL = EHR_API_PREFIX + "/prescriptionTemplates";
export const GET_DOCTOR_TREATMENT_PLAN_TEMPLATES_URL = GET_TREATMENT_PLAN_TEMPLATES_URL + "/doctor/$doctorId";
export const GET_TEMPLATE_TREATMENT_PLAN_TEMPLATES_URL = GET_TREATMENT_PLAN_TEMPLATES_URL + "/$templateId";
export const EHR_FETCH_MEDICAL_PAST_DATA = EHR_API_PREFIX + "/medicalProfileWrapper";


export const GET_ALL_GENERAL_EXAMINATION = ALBUS_API_PREFIX + "/getAllGeneralExamination";
// export const GET_APPOINTMENTS_URL = ALBUS_API_PREFIX + "/getAppointmentSchedule";
export const GET_APPOINTMENTS_URL = ALBUS_API_PREFIX + "/orders/consultation/search";
export const GET_ALL_VITALS = ALBUS_API_PREFIX + "/getAllVital";
export const GET_ALL_STATIC_DATA = ALBUS_API_PREFIX + "/getAllStaticData";
export const GET_ALL_PATIENT_VITALS = ALBUS_API_PREFIX + "/getAllVitalForPatient";
export const POST_ALL_VITALS = ALBUS_API_PREFIX + "/saveVitalForPatient";
export const GET_LAB_TESTS = ALBUS_API_PREFIX + "/orders/diagnostic/getReports";
export const GET_CHAT_CONTEXT = ALBUS_API_PREFIX + "/getTwilioChatContext";
export const GET_VIDEO_CONTEXT = ALBUS_API_PREFIX + "/getTwilioVideoContext";
export const GET_TWILIO_ACCESS_TOKEN = ALBUS_API_PREFIX + "/getTwilioAccessTokenList";
// export const PATIENT_MEDICAL_PROFILE_URL = EHR_API_PREFIX + "/patient/$patientId/medical-profile";
export const PATIENT_MEDICAL_PROFILE_URL = EHR_API_PREFIX + "/medicalProfileWrapper";

export const PATIENT_PRESCRIPTION_URL = ALBUS_API_PREFIX + "/createPrescription/$appointmentId";
export const PATIENT_SAVE_DIFFERENTIAL_DIAGNOSIS = ALBUS_API_PREFIX + "/updatePrescription";
export const PATIENT_SAVE_PRIVATE_NOTES = ALBUS_API_PREFIX + "/orders/consultation/$appointmentId/case-summary";
export const UPDATE_APPOINTMENT_STATUS_URL = ALBUS_API_PREFIX + "/orders/consultation/update/status/$bookingId/$appointmentId";
export const UPDATE_APPOINTMENT_URL = ALBUS_API_PREFIX + "/orders/consultation/update/status/$bookingId/$appointmentId";
export const GET_CENTER_DETAILS = ALBUS_API_PREFIX + "/getAllCenterDetails";
export const GET_RESOURCES = ALBUS_API_PREFIX + "/getResources";
export const GET_DIAGNOSTICS_STATIC_DATA = MAVERICK_API_PREFIX + "/care/diagnostic_catalogue";
export const GET_DISEASES_STATIC_DATA = MAVERICK_API_PREFIX + "/care/disease_catalogue";
export const GET_MEDICINES_STATIC_DATA = MAVERICK_API_PREFIX + "/care/medicine_catalogue";
export const GET_SYMPTOMS_STATIC_DATA = MAVERICK_API_PREFIX + "/care/symptom_catalogue";
export const GET_ALLERGY_STATIC_DATA = MAVERICK_API_PREFIX + "/care/allergies_catalogue";
export const GET_FITNESS_ACTIVITY_STATIC_DATA = MAVERICK_API_PREFIX + "/fitness/workout_tag_catalogue";
export const GET_LIFESTYLE_STATIC_DATA = MAVERICK_API_PREFIX + "/care/lifestyle_advice_catalogue";
export const UPLOAD_PRESCRIPTION = ALBUS_API_PREFIX + "/assets/upload/prescription";
export const UPLOAD_PLAN = ALBUS_API_PREFIX + "/assets/upload/plan";
export const DOWNLOAD_PRESCRIPTION = ALBUS_API_PREFIX + "/assets/download/prescription";
export const DOWNLOAD_CGM_REPORT = ALBUS_API_PREFIX + "/assets/download-cgmReport";
export const SEND_PRESCRIPTION = ALBUS_API_PREFIX + "/orders/consultation/sendPrescription/$bookingId/$appointmentId";
export const SEND_PLAN = ALBUS_API_PREFIX + "/orders/consultation/$appointmentId/plan";
export const GET_ROUTINE_ATTR = MAVERICK_API_PREFIX + "/attribute";
export const UPDATE_PATIENT_PERSONAL_INFO_URL = POLARIS_API_PREFIX + "/user/";
export const GET_PATIENT_LABTESTS_REPORT_PDF = ALBUS_API_PREFIX + "/assets/download/$userId/$bookingId/$orderId/$assetId";
export const GET_PATIENT_TYPEFORM_DATA = ALBUS_API_PREFIX + "/assessment/patient/result/patientId/HEALTH_ASSESSMENT";
export const GET_UNREAD_MESSAGE_INFO = ALBUS_API_PREFIX + "/doctor/doctorId/unread-messages";
export const UPDATE_CONSUMPTION_HORION = ALBUS_API_PREFIX + "/twilio/update/lastConsumedMessageIndex";
export const ADD_TWILIO_ROOM_EVENT_LOG = ALBUS_API_PREFIX + "/addTwilioRoomEventLogBulkV2";
export const FETCH_CONSULTATION_PRODUCT_INFO: string = ALBUS_API_PREFIX + "/product/info/$categoryCode";
export const GET_PRESIGNED_URL_FOR_UPLOAD: string = ALBUS_API_PREFIX + "/presigned-url-for-upload"
export const GET_DOC_ATTACHMENT_PRESIGNED_URL_FOR_DOWNLOAD: string = ALBUS_API_PREFIX + "/presigned-url-for-download"
export const SEARCH_PATIENTS: string = ALBUS_API_PREFIX + "/patient/search";
export const SEARCH_DOCTOR: string = OLLIVANDER_PREFIX + "/agents";

export const SAVE_PUSH_NOTIFICATION_SUBSCRIPTION: string = OLLIVANDER_PREFIX + "/agents/communication/mode/gcm/subscription/save?agentId={{agentID}}&communication_type=GCM_NOTIFICATION&communication_platform=$PLATFORM";
export const BLOCK_PUSH_NOTIFICATION_SUBSCRIPTION: string = OLLIVANDER_PREFIX + "/agents/communication/mode/gcm/subscription/block?agentId={{agentID}}&communication_type=GCM_NOTIFICATION&communication_platform=$PLATFORM";


export const CASE_SUMMARY_FOR_CONSULTATION: string =
    ORION_API_PREFIX +
    `/consultation/case-summary?appointmentId=${APPOINTMENT_ID_PARAM_CONST}`;
export const DOCTOR_SIGNATURE_IMAGE_DOWNLOAD_PRE_SIGNED_URL: string = ALBUS_API_PREFIX + "/doctor/$doctorId/signature-image-download-url";

export const GET_LAB_TESTS_STATIC_DATA = METRIC_SERVICE_API_PREFIX + "/metrics";
// export const GET_ROSTER: string = ALBUS_API_PREFIX + "/doctor/search?doctorId={{id}}&withWeeklySchedule=true";
export const GET_ROSTER: string = ALBUS_API_PREFIX + "/getSchedules";

export const UPDATE_ROSTER: string = ALBUS_API_PREFIX + "/updateSchedules/?action=CONFIRM";
export const CONSULTATION_FEEDBACK_URL = ALBUS_API_PREFIX + "/feedback/consultation-experience";
export const GET_CONSULTATIONS_COUNT_URL: string = ALBUS_API_PREFIX + "/orders/consultation/consultation-count";
export const GET_COVID_METRIC_IDS: string = ALBUS_API_PREFIX + "/staticData/covid-pack-info";
export const GET_COVID_VITALS: string = METRIC_SERVICE_API_PREFIX + "/user-metric/search";
export const GET_IS_ACTIVE_COVID_PACK: string = ALBUS_API_PREFIX + "/orders/bundle/active?userId=$userId&categoryCode=BUNDLE&subCategoryCode=CONSULTATION_PACK";

export const GET_SECTION_ALLOWED_URL: string = EHR_API_PREFIX + "/section-configurations/$sectionKey/doctor-type/$doctorType";
export const GET_DOCTOR_WISE_SUBSECTION_RECOMMENDATION_URL = CARE_RECOMMENDATION_SERVICE + "/$recommendationType/search";
export const GET_RECOM_TREATMENT_PLAN_TEMPLATES_URL = CARE_RECOMMENDATION_SERVICE + "/template-diagnosis-recommendation/search?doctor-id=$docId&count=$count";
export const DELETE_AGENT_ROSTER_URL = ALBUS_API_PREFIX + "/deleteAgentRoster"
export const FETCH_GLUCOSE_LEVELS_URL = ALBUS_API_PREFIX + "/staticData/glucose_levels"
export const FETCH_CGM_REPORT = ALBUS_API_PREFIX + "/cgm/librePro/cgm-report"
export const FETCH_CGM_STATS = ALBUS_API_PREFIX + "/cgm/librePro/cgm-stat"

export const ACCESS_POLICY_FETCH_URL: string = ALBUS_API_PREFIX + "/passlock/access-policy?principleReferenceEntity=$principleReferenceEntity&ownerReferenceEntity=$ownerReferenceEntity&ownerReferenceEntityId=$ownerReferenceEntityId&resourceType=$resourceType&principleReferenceEntityId=$principleReferenceEntityId";

export const ACCESS_POLICY_PUT_URL: string = ALBUS_API_PREFIX + "/passlock/access-policy";
export const EHR_SCHEDULED_INTERVENTIONS = EHR_API_PREFIX + "/scheduled-intervention";


export class AlbusUrlConfigs {
    public static getsavePushSubscriptionUrl(doctorId: number): string {
        const urlWithAgentId: string = SAVE_PUSH_NOTIFICATION_SUBSCRIPTION
            .replace("{{agentID}}", doctorId.toString())
            .replace("$PLATFORM", AppUtils.getIsMobile() ? PushNotificationPlatform.DOCS_APP_MWEB : PushNotificationPlatform.DOCS_APP)
        return ApiUtils.createApiUrl(urlWithAgentId)
    }

    public static getConsultationFeedbackUrl(): string {
        return ApiUtils.createApiUrl(CONSULTATION_FEEDBACK_URL);
    }

    public static getCovidMetricIds(): string {
        return ApiUtils.createApiUrl(GET_COVID_METRIC_IDS);
    }

    public static getIsActiveCovidPack(userId: number) {
        const isActivePackUrl = GET_IS_ACTIVE_COVID_PACK.replace("$userId", userId && userId.toString());
        return ApiUtils.createApiUrl(isActivePackUrl);
    }

    public static getCovidVitals(startEpoch: number, endEpoch: number, metricIds: string[], patientId: number, userId: string): string {
        const metricIdsStr = metricIds.join(", ");
        return ApiUtils.createApiUrl(`${GET_COVID_VITALS}?fromDateEpoch=${startEpoch}&toDateEpoch=${endEpoch}&count=20&sortDesc=true&userId=${userId}&metricId=${metricIdsStr}&subUserId=${patientId}`);
    }

    public static getBlockPushSubscriptionUrl(doctorId: number): string {
        const urlWithAgentId: string = BLOCK_PUSH_NOTIFICATION_SUBSCRIPTION
            .replace("{{agentID}}", doctorId.toString())
            .replace("$PLATFORM", AppUtils.getIsMobile() ? PushNotificationPlatform.DOCS_APP_MWEB : PushNotificationPlatform.DOCS_APP)
        return ApiUtils.createApiUrl(urlWithAgentId)
    }

    public static createGetDoctorProfileByIdUrl(doctorId: number): string {
        return ApiUtils.createApiUrl(GET_DOC_PROFILES + "?doctorId=" + doctorId);
    }

    public static getDoctorSearchURL(searchParams: ISearchDoctor): string {
        // const sanitizedSearchParams = new URLSearchParams(
        //     JSON.parse(JSON.stringify(
        //         { ...searchParams, "page-no": 0, "page-size": 1000 }
        //         )
        //     )
        // );
        const params = ApiUtils.requestToQueryParams({ ...searchParams, "page-no": 0, "page-size": 3000 })
        return ApiUtils.createApiUrl(`${SEARCH_DOCTOR}?${params}`);
    }

    public static createGetAllDoctorProfilesUrl(): string {
        return ApiUtils.createApiUrl(GET_DOC_PROFILES);
    }

    public static createGetStaticDataUrl(staticDataRequestParams: IStaticDataRequestParams): string {
        return ApiUtils.createApiUrl(GET_ALL_STATIC_DATA + "?" + ApiUtils.requestToQueryParams(staticDataRequestParams));
    }

    // public static createGetPatientCompleteDetailsByIdUrl(patientId: number, numberOfDays: number, startDateEpoch: number): string {
    //     return ApiUtils.createApiUrl(GET_PATIENT_COMPLETE_DETAILS_URL + "?patientId=" + patientId + "&prevNumOfDays=" + numberOfDays + "&startDateEpoch=" + startDateEpoch);
    // }
    public static createGetPatientCompleteDetailsByIdUrl(patientId: number, numberOfDays: number, startDateEpoch: number): string {
        return ApiUtils.createApiUrl(GET_PATIENT_COMPLETE_DETAILS_URL + `?patientId=${patientId}&prevNumOfDays=${numberOfDays}&startDateEpoch=${startDateEpoch}&doctorType=GP`);
    }

    public static createGetPatientByIdUrl(patientId: number): string {
        return ApiUtils.createApiUrl(GET_PATIENT_PROFILE + "?patientId=" + patientId);
    }

    public static createGetAppointmentDetailsById(appointmentId: number): string {
        return ApiUtils.createApiUrl(GET_APPOINTMENT_DETAILS_BY_ID + "?appointmentId=" + appointmentId);
    }

    public static createGetAppointmentsUrl(requestParams: IAppointmentScheduleRequestParams): string {
        return ApiUtils.createApiUrl(GET_APPOINTMENTS_URL + "?" + ApiUtils.requestToQueryParams(requestParams))
    }

    public static createSaveDoctorProfileUrl(doctorId: number) {
        return ApiUtils.createApiUrl(SAVE_DOC_PROFILE_BY_ID + "?doctorId=" + doctorId);
    }

    public static createGetSurgeryAndProcedureHistoryURL(patientId: number): string {
        return ApiUtils.createApiUrl(GET_SURGERY_AND_PROCEDURE_HISTORY + "?patientId=" + patientId);
    }

    public static createSaveSurgeryAndProcedureHistoryURL(patientId: number): string {
        return ApiUtils.createApiUrl(SAVE_SURGERY_AND_PROCEDURE_HISTORY + "/" + patientId);
    }

    public static createGetAllergyHistoryURL(patientId: number): string {
        return ApiUtils.createApiUrl(GET_ALLERGY_HISTORY + "?patientId=" + patientId);
    }

    public static getPatientPastSessionsURL(patientId: number, subSectionKey: string) {
        return ApiUtils.createApiUrl(GET_PAST_SESSIONS + `?patientId=${patientId}&subSectionKey=${subSectionKey}`)
    }
    public static createSaveAllergyHistoryURL(patientId: number): string {
        return ApiUtils.createApiUrl(SAVE_ALLERGY_HISTORY + "/" + patientId);
    }

    public static createGetHabitHistoryURL(patientId: number): string {
        return ApiUtils.createApiUrl(GET_HABIT_HISTORY + "?patientId=" + patientId);
    }

    public static createSaveHabitHistoryURL(patientId: number): string {
        return ApiUtils.createApiUrl(SAVE_HABIT_HISTORY + "/" + patientId);
    }

    public static createGetCurrentMedicationURL(patientId: number): string {
        return ApiUtils.createApiUrl(GET_CURRENT_MEDICATION_HISTORY + "?patientId=" + patientId);
    }

    public static createSaveCurrentMedicationURL(patientId: number): string {
        return ApiUtils.createApiUrl(SAVE_CURRENT_MEDICATION_HISTORY + "/" + patientId);
    }

    public static createGetComorbidConditionsURL(patientId: number): string {
        return ApiUtils.createApiUrl(GET_COMORBID_CONDITIONS_HISTORY + "?patientId=" + patientId);
    }

    public static createSaveComorbidConditionsURL(patientId: number): string {
        return ApiUtils.createApiUrl(SAVE_COMORBID_CONDITIONS_HISTORY + "/" + patientId);
    }

    public static createGetGeneralExaminationUrl() {
        return ApiUtils.createApiUrl(GET_ALL_GENERAL_EXAMINATION);
    }

    public static createGetVitalsUrl() {
        return ApiUtils.createApiUrl(GET_ALL_VITALS);
    }

    public static createGetAllVitalForPatientUrl(patientId: number) {
        return ApiUtils.createApiUrl(GET_ALL_PATIENT_VITALS + "?patientId=" + patientId);
    }

    public static createPostVitalsUrl(patientId: number) {
        return ApiUtils.createApiUrl(POST_ALL_VITALS + "/" + patientId);
    }

    public static createGetAllLabTestsForPatientUrl(patientId: number, requestParams: IDiagnosticOrderRequestParams) {
        return ApiUtils.createApiUrl(GET_LAB_TESTS + "?" + ApiUtils.requestToQueryParams(requestParams));
    }

    public static createGetTwilioContextUrl(requestParams: ICommAccessTokenRequestParams) {
        return ApiUtils.createApiUrl(GET_TWILIO_ACCESS_TOKEN + "?" + ApiUtils.requestToQueryParams(requestParams))
    }

    public static createGetVideoContextUrl(appointmentId: number) {
        return ApiUtils.createApiUrl(GET_VIDEO_CONTEXT + "?appointmentId=" + appointmentId)
    }

    public static createSavePatientMedicalProfileUrl(patientId: number, appointmentId: number) {
        return ApiUtils.createApiUrl(PATIENT_MEDICAL_PROFILE_URL + `/${patientId}?referenceId=${appointmentId}`);
    }

    public static createPatientPrescriptionUrl(appointmentId: number) {
        return ApiUtils.createApiUrl(PATIENT_PRESCRIPTION_URL.replace(APPOINTMENT_ID_PARAM_CONST, appointmentId.toString()));
    }

    public static createSaveDifferentialDiagnosisUrl(appointmentId: number) {
        return ApiUtils.createApiUrl(PATIENT_SAVE_DIFFERENTIAL_DIAGNOSIS + "?appointmentId=" + appointmentId);
    }

    public static createSavePrivateNotesUrl(appointmentId: number) {
        return ApiUtils.createApiUrl(PATIENT_SAVE_PRIVATE_NOTES.replace(APPOINTMENT_ID_PARAM_CONST, appointmentId.toString()));
    }

    public static fetchCaseSummary(appointmentId: number) {
        return ApiUtils.createApiUrl(
            CASE_SUMMARY_FOR_CONSULTATION.replace(
                APPOINTMENT_ID_PARAM_CONST,
                appointmentId.toString()
            )
        );
    }

    public static createUpdateAppointmentStatusUrl(bookingId: number, appointmentId: number) {
        return ApiUtils.createApiUrl(UPDATE_APPOINTMENT_STATUS_URL.replace(BOOKING_ID_PARAM_CONST, bookingId.toString()).replace(APPOINTMENT_ID_PARAM_CONST, appointmentId.toString()));
    }

    public static createUpdateAppointmentUrl(bookingId: number, appointmentId: number) {
        return ApiUtils.createApiUrl(UPDATE_APPOINTMENT_URL.replace(BOOKING_ID_PARAM_CONST, bookingId.toString()).replace(APPOINTMENT_ID_PARAM_CONST, appointmentId.toString()));
    }

    public static createGetCenterDetailsUrl(centerId: number) {
        return ApiUtils.createApiUrl(GET_CENTER_DETAILS + "?centerId=" + centerId);
    }

    public static createGetResourcesUrl(resourceRequestParams: IResourceRequestParams) {
        return ApiUtils.createApiUrl(GET_RESOURCES + "?" + ApiUtils.requestToQueryParams(resourceRequestParams));
    }

    public static createGetDiagnosticsUrl(input: string) {
        return ApiUtils.createApiUrl(GET_DIAGNOSTICS_STATIC_DATA + "?q=" + input + "&result-size=20");
    }


    public static createGetDiseasesUrl(input: string) {
        return ApiUtils.createApiUrl(GET_DISEASES_STATIC_DATA + "?q=" + input + "&result-size=20&on-properties=id,name");
    }

    public static createGetLifeStyleUrl(input: string) {
        return ApiUtils.createApiUrl(GET_LIFESTYLE_STATIC_DATA + "?q=" + input + "&result-size=20");
    }

    public static createGetMedicinesUrl(input: string) {
        return ApiUtils.createApiUrl(GET_MEDICINES_STATIC_DATA + "?q=" + input + "&result-size=20");
    }

    public static createUploadPrescriptionUrl(id: number, type: string) {
        return ApiUtils.createApiUrl(UPLOAD_PRESCRIPTION + "/" + id + "?assetType=" + type);
    }

    public static createUploadPlanUrl(id: number, type: string) {
        return ApiUtils.createApiUrl(UPLOAD_PLAN + "/" + id + "?assetType=" + type);
    }

    public static createDownloadPrescriptionUrl(id: number, type: string) {
        return ApiUtils.createApiUrl(DOWNLOAD_PRESCRIPTION + "/" + id + "?assetType=" + type);
    }

    public static createSendPrescriptionUrl(bookingId: number, appointmentId: number) {
        return ApiUtils.createApiUrl(SEND_PRESCRIPTION.replace(BOOKING_ID_PARAM_CONST, bookingId.toString()).replace(APPOINTMENT_ID_PARAM_CONST, appointmentId.toString()));
    }

    public static createSendPlanUrl(appointmentId: number, userId: string, bookingId: number) {
        return ApiUtils.createApiUrl(SEND_PLAN.replace(APPOINTMENT_ID_PARAM_CONST, appointmentId.toString()) + "?userId=" + userId + "&bookingId=" + bookingId);
    }

    public static createGetMedicineByMoleculesUrl(input: string) {
        return ApiUtils.createApiUrl(GET_MEDICINES_STATIC_DATA + "?q=" + input + "&result-size=20&on-properties=molecule");
    }

    public static createPatientPersonalUrl(input: string) {
        return ApiUtils.createApiUrl(UPDATE_PATIENT_PERSONAL_INFO_URL + input + "/lifestyle-profile");
    }

    public static createGetSymptomsByNameUrl(input: string) {
        return ApiUtils.createApiUrl(GET_SYMPTOMS_STATIC_DATA + "?q=" + input + "&result-size=5");
    }

    public static createGetAllergiesUrl(input: string) {
        return ApiUtils.createApiUrl(GET_ALLERGY_STATIC_DATA + "?q=" + input + "&result-size=20");
    }

    public static createGetFitnessActivitiesUrl(input: string) {
        return ApiUtils.createApiUrl(GET_FITNESS_ACTIVITY_STATIC_DATA + "?q=" + input);
    }

    public static createStaticRoutineAttrURL() {
        return ApiUtils.createApiUrl(GET_ROUTINE_ATTR);
    }

    public static createLogOrderEventUrl(orderEvent: IOrderEvent): string {
        return ApiUtils.createApiUrl(LOG_ORDER_EVENT_URL);
    }

    public static getDoctorSigUrl(doctor: IDoctor): string {
        return SIG_URL + "?img=" + doctor.signatureImage;
    }

    public static getDoctorSignatureUrl(signatureImage: string): string {
        return SIG_URL + "?img=" + signatureImage;
    }

    public static getReportsPdfUrl(userId: string, bookingId: number, orderId: number, assetId: string): string {
        return ApiUtils.createApiUrl(GET_PATIENT_LABTESTS_REPORT_PDF.replace(BOOKING_ID_PARAM_CONST, bookingId.toString()).replace(ORDER_ID_PARAM_CONST, orderId.toString())).replace(USER_ID_PARAM_CONST, userId).replace(ASSET_ID_PARAM_CONST, assetId);
    }

    public static createGetTypeFormDataUrl(patientId: number): string {
        return ApiUtils.createApiUrl(GET_PATIENT_TYPEFORM_DATA.replace(PATIENT_ID_PARAM, patientId.toString()));
    }

    public static createFetchUnreadMessageInfoDataUrl(doctorId: string, reqParams: IUnreadMsgInfoRequestParams): string {
        return ApiUtils.createApiUrl(GET_UNREAD_MESSAGE_INFO.replace(DOCTOR_ID_PARAM, doctorId.toString()) + "?" + ApiUtils.requestToQueryParams(reqParams));
    }

    public static createUpdateConsumptionHorizonUrl(): string {
        return ApiUtils.createApiUrl(UPDATE_CONSUMPTION_HORION);
    }

    public static addTwilioRoomEventLog(): string {
        return ApiUtils.createApiUrl(ADD_TWILIO_ROOM_EVENT_LOG);
    }

    public static createFetchConsultationProductUrl(categoryCode: string, productCode: string): string {
        let currUrl: string = `${FETCH_CONSULTATION_PRODUCT_INFO.replace("$categoryCode", categoryCode)}/?productCodeCsv=${productCode}`;
        return ApiUtils.createApiUrl(currUrl)
    };

    public static searchPatients(curefitUserId: string): string {
        return ApiUtils.createApiUrl(`${SEARCH_PATIENTS}?${ApiUtils.requestToQueryParams({ curefitUserId })}`)
    }

    public static getSearchDoctorPatientsUrl(doctorId: any, query: any) {
        const { sortOrder, pageNo, pageSize, patientNameContains } = query
        return ApiUtils.createApiUrl(`${ALBUS_API_PREFIX}/doctor/${doctorId}/patientInfo?sortOrder=${sortOrder}&page-no=${pageNo}&page-size=${pageSize}&patientNameContains=${patientNameContains}`)
    }

    public static getDoctorSignatureImageDownloadPreSignedUrl(doctorId: number): string {
        return ApiUtils.createApiUrl(DOCTOR_SIGNATURE_IMAGE_DOWNLOAD_PRE_SIGNED_URL.replace("$doctorId", doctorId.toString()))
    }
    public static createGetLabTestsUrl(input: string) {
        return ApiUtils.createApiUrl(GET_LAB_TESTS_STATIC_DATA + "?category=" + labTestCategories.diagnosti_profile + "&name=" + input)
    }
    public static getAddSymptomForReviewUrl() {
        return ApiUtils.createApiUrl(`${ALBUS_API_PREFIX}/symptoms/addSymptomForReview`)
    }

    public static getDoctorSubSectionsRecommendationsUrl() {
        return ApiUtils.createApiUrl(`${GET_DOCTOR_SUBSECTION_RECOMMENDATIONS_URL}`);
    }

    public static getDoctorTreatmentPlanTemplatesUrl(doctorId: number, diagnosis: Array<string> = []) {
        return ApiUtils.createApiUrl(`${GET_DOCTOR_TREATMENT_PLAN_TEMPLATES_URL.replace("$doctorId", doctorId.toString())}/template/diagnosis?value=` + JSON.stringify(diagnosis))
    }

    public static getDoctorAllTreatmentPlanTemplatesUrl(doctorId: number) {
        return ApiUtils.createApiUrl(`${GET_DOCTOR_TREATMENT_PLAN_TEMPLATES_URL.replace("$doctorId", doctorId.toString())}/all`);
    }

    public static getDoctorTreatmentPlanTemplatesByNameUrl(doctorId: number, query: string) {
        return ApiUtils.createApiUrl(`${GET_DOCTOR_TREATMENT_PLAN_TEMPLATES_URL.replace("$doctorId", doctorId.toString())}/template/name?value=${query}`)
    }

    public static getDoctorTreatmentPlanTemplatesByIdUrl(templateId: string) {
        return ApiUtils.createApiUrl(GET_TEMPLATE_TREATMENT_PLAN_TEMPLATES_URL.replace("$templateId", templateId));
    }

    public static getMedicalProfileUrl(patientId: number, appointmentId: number, doctorType: string) {
        const params = ApiUtils.requestToQueryParams({
            patientId,
            appointmentId,
            doctorType
        })
        return ApiUtils.createApiUrl(`${EHR_FETCH_MEDICAL_PAST_DATA}?${params}`);
    }

    // public static gerRosterUrl(params: IRosterRequest) {
    //     return ApiUtils.createApiUrl(GET_ROSTER).replace("{{id}}", params.resourceId.toString());
    // }

    public static gerRosterUrl(params: IRosterRequest) {
        const queryString: string = ApiUtils.requestToQueryParams(params);
        return ApiUtils.createApiUrl(GET_ROSTER) + "?" + queryString;
    }

    public static updateRosterUrl() {
        return ApiUtils.createApiUrl(UPDATE_ROSTER);
    }

    public static getConsultationsCountUrl(doctorId: string | number, fromTimeEpoch: number) {
        return ApiUtils.createApiUrl(`${GET_CONSULTATIONS_COUNT_URL}?${ApiUtils.requestToQueryParams({ doctorId, fromTimeEpoch })}`)
    }

    public static getSectionAllowedUrl(doctorType: string, sectionKey: string) {
        return ApiUtils.createApiUrl(GET_SECTION_ALLOWED_URL.replace("$sectionKey", sectionKey).replace("$doctorType", doctorType))
    }

    public static getPreSignedUrlForUpload(referenceType: string, referenceId: string) {
        const params = ApiUtils.requestToQueryParams({
            referenceType,
            referenceId
        }, true)
        return ApiUtils.createApiUrl((`${GET_PRESIGNED_URL_FOR_UPLOAD}?${params}`))
    }

    public static getDocPreSignedUrlForDownload(referenceType: string, referenceId: string, s3KeyName: string) {
        const params = ApiUtils.requestToQueryParams({
            referenceType,
            referenceId,
            s3KeyName
        }, true)
        return ApiUtils.createApiUrl((`${GET_DOC_ATTACHMENT_PRESIGNED_URL_FOR_DOWNLOAD}?${params}`))
    }

    public static getDoctorWiseSubSectionRecommendations(recommendationType: string) {
        return ApiUtils.createApiUrl(GET_DOCTOR_WISE_SUBSECTION_RECOMMENDATION_URL.replace("$recommendationType", recommendationType));
    }

    public static getAccessPolicyFetchUrl(principleReferenceEntity: string, ownerReferenceEntity: string, ownerReferenceEntityId: string, resourceType: string, principleReferenceEntityId: string): string {
        return ACCESS_POLICY_FETCH_URL
            .replace("$principleReferenceEntity", principleReferenceEntity)
            .replace("$ownerReferenceEntity", ownerReferenceEntity)
            .replace("$ownerReferenceEntityId", ownerReferenceEntityId)
            .replace("$resourceType", resourceType)
            .replace("$principleReferenceEntityId", principleReferenceEntityId);
    }

    public static getAccessPolicyPutUrl(): string {
        return ACCESS_POLICY_PUT_URL;
    }


    public static getRecoTreatementPlanFetchUrl(doctorId: number, count: number): string {
        return ApiUtils.createApiUrl(GET_RECOM_TREATMENT_PLAN_TEMPLATES_URL
            .replace("$docId", doctorId.toString())
            .replace("$count", count.toString()));
    }

    public static getDeleteAgentRosterUrl(): string {
        return ApiUtils.createApiUrl(DELETE_AGENT_ROSTER_URL)
    }

    public static getFetchGlucoseLevelsUrl(levelCode?: string): string {
        const params = levelCode ? ApiUtils.requestToQueryParams({ level_code: levelCode }) : null
        return params
            ? `${FETCH_GLUCOSE_LEVELS_URL}?${params}`
            : FETCH_GLUCOSE_LEVELS_URL
    }

    public static getFetchCgmReportUrl(userId: string): string {
        return ApiUtils.createApiUrl(`${FETCH_CGM_REPORT}?userId=${userId}`);
    }

    public static getFetchCgmStatsUrl(userId: string): string {
        return ApiUtils.createApiUrl(`${FETCH_CGM_STATS}?userId=${userId}`);
    }

    public static getScheduledInterventionsProgress(patientId: string) {
        return ApiUtils.createApiUrl(`${EHR_SCHEDULED_INTERVENTIONS}/progress/${patientId}`);
    }

    public static getScheduledInterventions() {
        return ApiUtils.createApiUrl(`${EHR_SCHEDULED_INTERVENTIONS}`);
    }

    public static getScheduledInterventionsHistory(patientId: string) {
        return ApiUtils.createApiUrl(`${EHR_SCHEDULED_INTERVENTIONS}/fetch/scheduled-interventions?patientId=${patientId}`);
    }
    public static getCgmReportUrl(patientId: string) {
        return ApiUtils.createApiUrl(`${DOWNLOAD_CGM_REPORT}/${patientId}`);
    }
}